import {
  IconAnalytics,
  IconBell,
  IconBinocularsGray,
  IconCar,
  IconCctvLine,
  IconChainLink,
  IconChartBar,
  IconChartBarGray,
  IconChartRadius,
  IconClockGray,
  IconCloudCheckGray,
  IconDashboard,
  IconLayers,
  IconLocation,
  IconRoute,
  IconRulerGray,
  IconSearch,
  IconSecurity,
  IconTagGray,
  IconTvocGray,
  IconWarning,
  IconZoneGray,
} from '@assets/images/icon';
import { rtlsSystem } from '@assets/images/solution';
import mainVideo from '@src/assets/images/solution/constructionSafety/video/rtlsVideo.mp4';
import subVideo1 from '@src/assets/images/solution/constructionSafety/video/sub/rtlsVideo1.mp4';
import subVideo2 from '@src/assets/images/solution/constructionSafety/video/sub/rtlsVideo2.mp4';
import subVideo3 from '@src/assets/images/solution/constructionSafety/video/sub/rtlsVideo3.mp4';
import subVideo4 from '@src/assets/images/solution/constructionSafety/video/sub/rtlsVideo4.mp4';
import subVideo5 from '@src/assets/images/solution/constructionSafety/video/sub/rtlsVideo5.mp4';

import image1 from '@src/assets/images/solution/constructionSafety/img/1.avif';
import image2 from '@src/assets/images/solution/constructionSafety/img/2.avif';
import image3 from '@src/assets/images/solution/constructionSafety/img/3.avif';
import image4 from '@src/assets/images/solution/constructionSafety/img/4.avif';

export default {
  type: '建筑解决方案',
  banner: {
    title: '即时检测并应对施工现场作业人员风险',
    desc: '实时掌握作业人员位置，发生危险时立即响应，有效提升现场安全管理水平。',
  },

  video: {
    title: '通过实时位置数据优化施工现场安全管理',
    desc: '精准追踪现场作业人员的实时位置，提前识别风险并快速应对，从而提高现场的安全性与运营效率。',
    play: mainVideo,
  },

  func: [
    {
      theme: '实时监控作业人员位置，最大限度降低事故风险',
      title: '作业人员位置实时追踪',
      desc: '以±50cm以内的高精度实时掌握作业人员当前位置，及时检测现场潜在风险，快速采取应对和预防措施。',
      sub1: '高精度定位',
      icon1: IconRulerGray,
      sub2: '实时状态监控',
      icon2: IconClockGray,
      video: subVideo1,
    },
    {
      title: '危险区域进入自动警报',
      desc: '当作业人员接近或进入指定危险区域时，管理人员会即时收到警报通知，从而保障作业人员安全，防范潜在事故。',
      sub1: '实时位置追踪',
      icon1: IconBinocularsGray,
      sub2: '快速数据联动',
      icon2: IconTvocGray,
      video: subVideo2,
    },
    {
      title: '重型设备位置同步管理',
      desc: '为重型设备安装定位标签，实时管理设备移动路径及当前位置，与作业人员信息统一管理，降低碰撞风险并提升设备运作效率。',
      sub1: '实时位置追踪',
      icon1: IconBinocularsGray,
      sub2: '高精度定位',
      icon2: IconRulerGray,
      video: subVideo3,
    },
    {
      title: '作业人员轨迹记录及事故预防',
      desc: '记录作业人员的移动轨迹，在发生事故时快速应对，并通过分析高风险路径优化安全管理计划。',
      sub1: '统计数据提供',
      icon1: IconChartBarGray,
      sub2: '云端数据存储',
      icon2: IconCloudCheckGray,
      video: subVideo4,
    },
    {
      theme: '用数据记录安全，开启更高效的现场运营',
      title: 'CCTV联动安全监控',
      desc: '将作业人员位置数据与现场CCTV视频实时联动，直观掌握现场状况。发生危险时，可立即通过视频确认人员位置及周边环境，实现更快速、准确的应对。',
      sub1: '灵活区域设置',
      icon1: IconZoneGray,
      sub2: '多区域配置',
      icon2: IconTagGray,
      image: image1,
    },
    {
      title: '自动生成安全管理报告',
      desc: '安全管理报告可按日或按周自动生成并发送给管理人员，系统化整理事故状况与预防措施结果，实现高效安全管理。',
      sub1: '灵活区域设置',
      icon1: IconZoneGray,
      sub2: '多区域配置',
      icon2: IconTagGray,
      image: image2,
    },
    {
      title: '危险事件记录数据分析',
      desc: '分析历史危险事件及作业人员移动数据，精准掌握事故高发区域及情形，并据此优化未来的安全管理计划。',
      sub1: '灵活区域设置',
      icon1: IconZoneGray,
      sub2: '多区域配置',
      icon2: IconTagGray,
      image: image3,
    },
    {
      title: '人员配置优化支持',
      desc: '分析作业人员密集度及移动数据，优化现场人员配置，实现高效人员管理，降低运营成本。',
      sub1: '灵活区域设置',
      icon1: IconZoneGray,
      sub2: '多区域配置',
      icon2: IconTagGray,
      image: image4,
    },
  ],

  subfunc: {
    title: '主要功能概览',
    desc: '',

    data: [
      {
        icon: IconLocation,
        title: '作业人员位置实时追踪',
        desc: '以±50cm的高精度实时追踪作业人员位置。',
      },
      {
        icon: IconWarning,
        title: '危险区域进入自动警报',
        desc: '作业人员进入危险区域时即时向管理人员发送通知。',
      },
      {
        icon: IconCar,
        title: '重型设备位置同步监控',
        desc: '同时监控重型设备与作业人员位置，防止碰撞风险。',
      },
      {
        icon: IconRoute,
        title: '作业人员轨迹记录',
        desc: '自动记录作业人员移动轨迹，用于风险预防及快速应对。',
      },
      {
        icon: IconCctvLine,
        title: 'CCTV联动支持',
        desc: '作业人员位置与CCTV视频联动，实时可视化现场情况。',
      },
      {
        icon: IconChartBar,
        title: '安全管理报告生成',
        desc: '自动分析安全状态和事故数据，生成报告。',
      },
      {
        icon: IconSearch,
        title: '人员密集度管理',
        desc: '实时管理人员密集度，超出阈值时自动发出提醒。',
      },
      {
        icon: IconLayers,
        title: '人员配置优化支持',
        desc: '分析人员密集度，实现人员的高效配置。',
      },
      {
        icon: IconAnalytics,
        title: '危险数据分析',
        desc: '分析历史危险数据，制定事故预防计划。',
      },
      {
        icon: IconSecurity,
        title: '安全审计与合规记录',
        desc: '将作业人员位置及轨迹数据用于审计和合规资料。',
      },
    ],
  },

  system: {
    title: '系统构成',
    img: rtlsSystem,
  },

  productTitle: '产品构成',
  product: [
    {
      tag: 'workerPackage',
    },
    {
      tag: 'assetPackage',
    },
  ],

  contents: [
    {
      data: 'constructionAsset',
    },
    {
      data: 'constructionEquipment',
    },
    {
      data: 'blogRTLS',
    },
    {
      data: 'blogMedical',
    },
  ],
};
